var $ = jQuery;

import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';

$(document).on('ready', function(){
    if($('.benefits-swiper').length){
      $('.benefits-swiper').each(function(index){
          new Swiper($(this)[0], {
          modules: [Mousewheel],
          slidesPerView: 6.5,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
          },
          loop: false,
          spaceBetween: 20,
          autoHeight: true,
          slidesOffsetAfter: 48,
          breakpoints: {
            300: {
              slidesPerView: 1.6,
              speed:800,
              autoHeight: false,
            },
            500: {
              slidesPerView: 2,
              speed:800,   
              autoHeight: false,
            },
            1000: {
              slidesPerView: 4.1,
              autoHeight: true,
            },
            1400: {
              slidesPerView: 6.1,
              autoHeight: true,
            },
          },
        });
      });
    }
  });
